
  import { Component, Prop, Vue } from 'vue-property-decorator'
  
  @Component
  export default class timePopup extends Vue {

    popShow = false
    isShowDatetimePicker = false
    pickerType = 0 // 0初始状态 1微店营业开始时间 2微店营业结束时间 3到店提货开始时间 4到店提货结束时间
    pickupStartTime = ''
    pickupEndTime = ''
    takeStartTime = ''
    takeEndTime = ''
    currentTimeMap = {
      1: this.takeStartTime,
      2: this.takeEndTime,
      3: this.pickupStartTime,
      4: this.pickupEndTime
    }

    get currentTime() {
      return this.currentTimeMap[this.pickerType]
    }

    showPop(params) {
      params && (this.pickupStartTime = params.pickupStartTime || '00:00')
      params && (this.pickupEndTime = params.pickupEndTime || '05:00')
      params && (this.takeStartTime = params.takeStartTime || '00:00')
      params && (this.takeEndTime = params.takeEndTime || '05:00')
      params && (this.pickerType = params.pickerType || 1)
      this.currentTimeMap = {
        1: this.takeStartTime,
        2: this.takeEndTime,
        3: this.pickupStartTime,
        4: this.pickupEndTime,
      }
      this.popShow = true
      this.isShowDatetimePicker = true
    }

    onCancel() {
      this.popShow = false
      this.isShowDatetimePicker = false
      this.pickerType = 0
    }
  
    onConfirm() {
      this.popShow = false
      this.isShowDatetimePicker = false
      this.pickerType = 0
      const payload = {
        pickupStartTime: this.pickupStartTime,
        pickupEndTime: this.pickupEndTime,
        takeStartTime: this.takeStartTime,
        takeEndTime: this.takeEndTime
      }
      this.$emit('confirm', payload)
    }
  
    onSelect(type: any) {
      // this.isShowDatetimePicker = true
      this.pickerType = type
    }
  
    onChange(e: any) {
      const val = e.getValues()
      const timeStr = val.join(':')
      this.currentTimeMap[this.pickerType] = timeStr
      switch (this.pickerType) {
        case 1:
          this.takeStartTime = timeStr
          break
        case 2:
          this.takeEndTime = timeStr
          break
        case 3:
          this.pickupStartTime = timeStr
          break
        case 4:
          this.pickupEndTime = timeStr
          break
        default:
          break
      }
    }
  }
  